<div class="button-container">
  <button class="circular-button edit" (click)="onEdit($event)">
    <i class="fa fa-pencil"></i>
  </button>
  <button class="circular-button duplicate" (click)="onDuplicate($event)">
    <i class="fa fa-files-o"></i>
  </button>
  <button class="circular-button delete" (click)="onDelete($event)">
    <i class="fa fa-trash-o"></i>
  </button>
</div>